import { makeJsonApiRequest } from '../base/axios.ts'

export default {
  // loads permissions for a given permissionable
  loadPermissionsForPermissionable: (permissionableType, permissionableId) =>
    makeJsonApiRequest({
      url: `/api/v2/permissions/for_permissionable`,
      method: 'get',
      data: undefined,
      params: {
        permission: {
          permissionable_id: permissionableId,
          permissionable_type: permissionableType,
        },
      },
      requestId: `get-permissions-for-permissionable-${permissionableType}:${permissionableId}`,
    }),

  // creates single permission
  createPermission: data =>
    makeJsonApiRequest({
      url: `/api/v2/permissions`,
      method: 'post',
      data,
      requestId: `create-permission`,
    }),

  // creates multiple user permissions
  bulkCreatePermissions: data =>
    makeJsonApiRequest({
      url: `/api/v2/permissions/bulk_create`,
      method: 'post',
      data,
      requestId: `bulk-create-permissions`,
    }),

  // revokes permission
  revokePermission: id =>
    makeJsonApiRequest({
      url: `/api/v2/permissions/${id}`,
      method: 'delete',
      requestId: `delete-permission-${id}`,
    }),

  // fetches groups that user is a member of
  fetchGroups: () =>
    makeJsonApiRequest({
      url: `/api/v2/permissions/groups`,
      method: 'get',
      requestId: `get-groups`,
    }),
}
